import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * NavbarMenu - A className-based implementation that matches the Bulma NavbarMenu
 * 
 * This component provides the same API as Bloomer's NavbarMenu for easy migration
 */
const NavbarMenu = ({
  children,
  className,
  isActive,
  ...rest
}) => {
  const navbarMenuClasses = classNames('navbar-menu', {
    'is-active': isActive,
    [className]: className,
  });

  return (
    <div className={navbarMenuClasses} {...rest}>
      {children}
    </div>
  );
};

NavbarMenu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isActive: PropTypes.bool,
};

NavbarMenu.defaultProps = {
  children: null,
  className: '',
  isActive: false,
};

export default NavbarMenu;
